import React, { useEffect, useState } from 'react';
import { Form, Tooltip, Modal, List as AntList, Typography, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ColumnsType } from 'antd/es/table';
import { Notification } from '@presentation/components/common';
import { List, DataType, getFieldsForFilter, getPageAndPerPage } from '@presentation/components/form';
import Header from './header';

import schedule from '@core/modules/schedule/infra/container.registry';
import { Schedule } from '@core/modules/schedule/domain/schedule.entities';
import ButtonsBar from '@/@presentation/components/form/ButtonsBar';
import Status from './status';
import { Receiver } from './receiver';
import StepsButton from './stepsButton';
import { ProcedureValueUpdate } from './procedureValueUpdate';
import { useItemsContext } from '@/@presentation/contexts/schedulesContext';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { auth } from '@/@core/modules/authentication/infra/container.registry';
import { Payer } from './payer';
import { CloseOutlined } from '@ant-design/icons';
import conciliator from '@/@core/modules/conciliator/infra/container.registry';

const HomeList = () => {
    const navigate = useNavigate();

    const { setOrigin } = useItemsContext()

    setOrigin('')

    const [modalVisible, setModalVisible] = React.useState(false);
    const [receiverVisible, setReceiverVisible] = React.useState(false);
    const [payerVisible, setPayerVisible] = React.useState(false);
    const [dataPayerError, setDataPayerError] = useState(false);
    const [pagador, setPagador] = useState('')
    
    const [params, setParams] = React.useState<Schedule>();
    const [loading, setLoading] = React.useState(false);
    const [isReload, setReload] = React.useState(true);
    const [currentStep, setCurrentStep] = React.useState(0);
    const [onlyRead, setOnlyRead] = React.useState(false);

    const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
    const [selectedItems, setSelectedItems] = React.useState<any[]>([]);

    const [customerSelected, setSelectedCustomer] = useState<any>()
    const [payerSelected, setPayerSelected] = useState<any>()
    const [isBackoffice, setIsBackoffice] = useState(false);

    const [executeFunction, setExecuteFunction] = useState('');

    const [viewProcedureValue, setViewProcedureValue] = useState(false);
    const [historyModalVisible, setHistoryModalVisible] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState<{
        id: number;
        history?: Array<{ modifiedBy: string; modifiedAt: string; observations: string }>;
    } | null>(null);
    const [loadingHistory, setLoadingHistory] = useState(false);

    const getUser = async () => {
        const userInfos = await auth.userInfos.execute();
        setIsBackoffice(userInfos?.props.type === 'BACKOFFICE');
    }

    const onChangeRowKey = (newSelectedRowKeys: React.Key[], newSelectedRows: Schedule[]) => {
        //newSelectedRowKeys só leva em consideração a pagina atual
        const removedRowKeys = selectedRowKeys.filter(key => !newSelectedRowKeys.includes(key));
        const removedItems = selectedItems.filter(item => removedRowKeys.includes(item.id));

        const addedRowKeys = newSelectedRowKeys.filter(key => !selectedRowKeys.includes(key));
        const addedItems = newSelectedRows.filter(item => !selectedItems.some(selectedItem => selectedItem.id === item.id));

        const updatedRowKeys = [...selectedRowKeys.filter(key => !removedRowKeys.includes(key)), ...addedRowKeys];
        const updatedItems = [...selectedItems.filter(item => !removedItems.some(removedItem => removedItem.id === item.id)), ...addedItems];
    
        setSelectedRowKeys(updatedRowKeys);
        setSelectedItems(updatedItems);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onChangeRowKey,
        preserveSelectedRowKeys: true,
        getCheckboxProps: (record: any) => ({
            disabled: (!record.canEdit && !isBackoffice) || record.schedulePaymentTypeId === 4,
        }),
    };

    const onChangeStep = (value: number) => {
        setCurrentStep(value);
    };

    async function loadData(params?: any) {
        params.ignoreCanceled = 'true'

        const selectedIds = selectedItems.map(item => item.id);
        if (selectedIds.length > 0) {
            params.selectedIds = selectedIds;
        }

        const baseParams = getPageAndPerPage(params || {});
        const filterParams = getFieldsForFilter(params || {});
        
        return await schedule.getAll.execute({
            ...baseParams,
            ...filterParams,
            ignoreCanceled: 'true',
            isFinance: true
        });
    }

    const checkIsSelected = (id: string) => {
        return selectedRowKeys.includes(id);
    }

    const rowClickProps = (record: any, columnIndex: number) => {

        const isSelected = checkIsSelected(record.id);

        if (isSelected) {
            Notification.error({
                message: `Por favor, desmarque o ID ${record.id} para realizar a alteração.`,
                duration: 2,
            });

            return;
        }

        const isColumnValue = columnIndex === 2

        const disabledWithNF = record?.statusInvoice === 'Emitido' || record?.statusInvoice === 'Solicitado'
        if (disabledWithNF && isColumnValue) {
            Notification.error({
                message: 'Não é possivel alterar o valor desse item!',
                duration: 2,
            });

            return;
        }

        if (columnIndex === 1) {
           
            if (
                record?.statusBilling !== 'pending' && 
                record?.statusBilling !== 'paid' &&
                record?.schedulePaymentTypeId !== 5 && 
                record?.statusInvoice !== 'Emitido' &&
                record?.statusInvoice !== 'Solicitado' &&
                record?.status !== 'canceled' 
            
            )
            {
                setOnlyRead(false)
                setSelectedCustomer(record)
                setReceiverVisible(true)
            }else{
                setOnlyRead(true)
                setSelectedCustomer(record)
                setReceiverVisible(true)
                /*
                Notification.error({
                    message: 'Não é possivel alterar o tomador desse item!',
                    duration: 2,
                });
                */
            }
        } else if (columnIndex === 2) {
            if (
                record?.statusBilling !== 'pending' &&
                record?.statusBilling !== 'paid' &&
                record?.schedulePaymentTypeId !== 5 &&
                record?.statusInvoice !== 'Emitido' &&
                record?.statusInvoice !== 'Solicitado' &&
                record?.status !== 'canceled' ||
                (
                    record?.total != 'R$ 0,00' &&
                    record?.updatedBySecretary === true && // @TODO - aqui que bloqueia o valor
                    record?.statusBilling !== 'paid' &&
                    record?.statusBilling !== 'pending' &&
                    record?.schedulePaymentTypeId !== 5
                )
            ) {
                setSelectedCustomer(record)
                setViewProcedureValue(true)
            } else {
                Notification.error({
                    message: 'Não é possivel alterar o valor desse item!',
                    duration: 2,
                });
            }
        } 
        else if (columnIndex === 3) {
            setPayerSelected(record)
            setPayerVisible(true)
        } else {
            setOrigin('payment')
            navigate(`/schedule/${record?.id}`, {
                state: {canEdit: record?.canEdit},
            });
        }
    }

    const handleShowHistory = async (record: any) => {
        setLoadingHistory(true);
        setHistoryModalVisible(true);
        setSelectedHistory({ id: record.id, history: [] });
        try {
            const history = await conciliator.getHistory.execute({ scheduleId: record.id });
            setSelectedHistory({ id: record.id, history: history || [] });
        } catch {
            setSelectedHistory({ id: record.id, history: [] });
        } finally {
            setLoadingHistory(false);
        }
    };

    const handleCloseHistory = () => {
        setHistoryModalVisible(false);
        setSelectedHistory(null);
    };

    const columns: ColumnsType<DataType> = [
        ...(isBackoffice
            ? [
                  {
                      title: 'Histórico',
                      key: 'historico',
                      width: 70,
                      align: 'center' as const,
                      fixed: 'left' as const,
                      render: (_: unknown, record: any) => (
                          <Tooltip title={record.id}>
                              <EyeOutlined
                                  style={{ color: '#1890ff', cursor: 'pointer', fontSize: 18 }}
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      handleShowHistory(record);
                                  }}
                              />
                          </Tooltip>
                      ),
                  },
              ]
            : []),
        {
            title: 'ID ',
            dataIndex: 'id',
            fixed: 'left',
            align: 'center',
            render: (id) => (
                <a>{id}</a>
            ),
            onCell: (record, rowIndex) => {
                return {
                    onClick: (e) => {
                        e.stopPropagation();
                        rowClickProps(record, 0);
                    },
                };
            },
        },
        {
            title: 'Data Procedimento ',
            dataIndex: 'procedureDate',
            sortDirections: ['descend'],
            align: 'center',
            ellipsis: true,
        },
        // {
        //     title: 'Hora Procedimento ',
        //     dataIndex: 'procedureHour',
        //     sortDirections: ['descend'],
        //     align: 'center',
        //     render: (procedureHour) => (
        //         <p>{String(procedureHour).slice(8, -3)}</p>
        //     ),
        // },
        {
            title: 'Paciente',
            dataIndex: 'patient',
            defaultSortOrder: 'descend',
            render: (unit) => (
                <Tooltip placement="topLeft" title={unit}>
                    {unit?.length > 20 ? `${unit.substring(0, 20)}...` : unit}
                </Tooltip>
            ),
        },
        {
            title: 'Unidade',
            dataIndex: 'unit',
            defaultSortOrder: 'descend',
            render: (unit) => (
                <Tooltip placement="topLeft" title={unit}>
                    {unit?.length > 20 ? `${unit.substring(0, 20)}...` : unit}
                </Tooltip>
            ),
        },
        {
            title: 'Cirurgião',
            dataIndex: 'surgeon',
            defaultSortOrder: 'descend',
            render: (surgeon) => (
                <Tooltip placement="topLeft" title={surgeon}>
                    {surgeon?.length > 23 ? `${surgeon.substring(0, 23)}...` : surgeon}
                </Tooltip>
            ),
        },
        {
            title: 'Procedimento',
            dataIndex: 'procedure',
            defaultSortOrder: 'descend',
            render: (procedure) => (
                <Tooltip placement="topLeft" title={procedure}>
                    {procedure?.length > 26 ? `${procedure.substring(0, 26)}...` : procedure}
                </Tooltip>
            ),
        },
        {
            title: 'Valor',
            dataIndex: 'total',
            defaultSortOrder: 'descend',
            render: (total, record: any) => {
                // let color = '#1677ff';
                // if (total === 'R$ 0,00')
                //     color = '#ed0707'
                if (record.canEdit || isBackoffice) {
                    return <a><EditOutlined /> {total}</a>
                }

                return <p>{total}</p>
            },
            onCell: (record: any, rowIndex) => {
                return {
                    onClick: (e) => {
                        if (record.canEdit || isBackoffice) {
                            e.stopPropagation();
                            rowClickProps(record, 2);
                        }
                    },
                };
            },
        },
        {
            title: 'Nome do Tomador',
            dataIndex: 'receiverName',
            defaultSortOrder: 'descend',
            render: (receiverName, record: any) => {
                // let color = '#1677ff';
                // if (record.paymentCustomer.id === 0)
                //     color = '#ed0707' 
                if (record?.canEdit || isBackoffice) {
                    return <a><EditOutlined /> {receiverName}</a>
                }

                return <p>{receiverName}</p>
            },
            onCell: (record: any, rowIndex) => {
                return {
                    onClick: (e) => {
                        if (record.canEdit || isBackoffice) {
                            e.stopPropagation();
                            rowClickProps(record, 1);
                        }
                    },
                };
            },
        },
        {
            title: 'Nome do Pagador',
            dataIndex: 'payerName', 
            defaultSortOrder: 'descend',
            render: (payerName) => (
                payerName ? (
                    <a><EyeOutlined /> {payerName}</a>
                ) : <a>-</a>
            ),
            onCell: (record: any, rowIndex) => {
                return {
                    onClick: (e) => {
                        if(record.payerCustomer && record.payerCustomer !== undefined && Object.keys(record.payerCustomer).length > 0){
                            e.stopPropagation();
                            rowClickProps(record, 3); 
                        }
                            
                    },
                };
            },
        },
        {
            title: 'Forma de Pagamento',
            defaultSortOrder: 'descend',
            align: 'center',
            responsive: ['sm'],
            render: (item) => {
                if (item?.schedulePaymentTypeId === 4) {
                    return 'CONVÊNIO'
                } else {
                    return (
                        <Tooltip placement="topLeft" title={!item?.methodCode? '-' : item?.methodCode === 'bank_slip' ? `BOLETO` : item?.methodCode === 'credit_card' ? 'CRÉDITO' : item?.methodCode.toUpperCase()} style={{textTransform: 'uppercase'}}>
                    {!item?.methodCode? '-' : item?.methodCode === 'bank_slip' ? `BOLETO` : item?.methodCode === 'credit_card' ? 'CRÉDITO' : item?.methodCode.toUpperCase()}
                </Tooltip>
                    )
                }
            },
        },
        {
            title: 'Status Pagamento',
            dataIndex: '',
            defaultSortOrder: 'descend',
            render: (record) => (
                <Status key={record?.id} item={record} />
            ),

            responsive: ['sm'],
        },
        {
            title: 'Baixar NFe',
            align: 'center',
            width: 100,
            render: (record) => (
                <img
                    key={record?.id}
                    src={record?.invoiceUrl ? "/pdfIcon.svg" : "/pdfIconGray.svg"}
                    onClick={() => {
                        if (record?.invoiceUrl) {
                            window.open(record.invoiceUrl.replace('$1', '?'), '_blank');
                        }
                    }}
                    style={{
                        cursor: record?.invoiceUrl ? 'pointer' : 'not-allowed',
                        height: 23,
                        width: 23,
                        alignContent: 'center',
                        alignItems: 'center',
                        opacity: record?.invoiceUrl ? 1 : 0.5,
                    }}
                />
            ),
            responsive: ['sm'],
        },
        {
            title: 'Botões de Ação',
            dataIndex: '',
            key: 'x',
            align: 'center',
            render: (record) => (
                <StepsButton
                    id={record?._id}
                    onChange={onChangeStep}
                    current={currentStep}
                    item={record} />
            ),
        },
    ]

    const removeItem = (ids: string | string[], callback?: 'nf' | 'payment' | '') => {
        const idsToRemove = Array.isArray(ids) ? ids : [ids];
    
        const idsToRemoveSet = new Set(idsToRemove);

        const updatedItems = selectedItems.filter(item => !idsToRemoveSet.has(item.id));
        setSelectedItems(updatedItems);
    
        const updatedKeys = selectedRowKeys.filter((key: string) => !idsToRemoveSet.has(key));
        setSelectedRowKeys(updatedKeys);

        if (callback !== undefined && callback !== null) {
            setExecuteFunction(callback);
        }
    }

    useEffect(() => {
        getUser()
    }, [loading])
    
    useEffect(() => {
        setSelectedItems([]);
        setSelectedRowKeys([]);
    }, []);

    const selectedView = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                <span style={{ color: '#1890ff', fontSize: 14, fontWeight: 'bold', marginBottom: 10, marginLeft: 10 }}>
                    {selectedItems.length} item(s) selecionado(s)
                </span>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        paddingLeft: 10,
                    }}
                >
                    {selectedItems.map((item, index) => (
                        <span
                            key={index}
                            style={{
                                backgroundColor: '#1890ff',
                                fontSize: 14,
                                fontWeight: 'bold',
                                color: '#fff',
                                padding: '5px 8px',
                                borderRadius: 5,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {item.id}
                            <CloseOutlined
                                onClick={() => removeItem(item.id)}
                                style={{
                                    cursor: 'pointer',
                                    marginLeft: 5,
                                }}
                            />
                        </span>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <>
            <Receiver
                visible={receiverVisible}
                setVisible={setReceiverVisible}
                onlyRead={onlyRead}
                data={customerSelected}
                setReload={setReload}
                setItemBase={() => console.log()}
            />
            <Payer
                visible={payerVisible}
                setVisible={setPayerVisible}
                data={[payerSelected]}//{itemBase}
                onlyRead={true}
                setReload={setReload}
                setItemBase={()=>console.log()}//
                setDataPayerError={setDataPayerError}
                dataPayerError={dataPayerError}
                setPagador={setPagador}
            />
            <ProcedureValueUpdate
                visible={viewProcedureValue}
                setVisible={setViewProcedureValue}
                data={customerSelected}
                setReload={setReload}
            />

            <div>
                <List
                    rowSelection={rowSelection}
                    columns={columns}
                    loadData={loadData}
                    Form={Form}
                    setLoading={setLoading}
                    loading={loading}
                    setModalVisible={setModalVisible}
                    modalVisible={modalVisible}
                    setParams={setParams}
                    params={params}
                    setReload={setReload}
                    isReload={isReload}
                    showStatusBillingFilter
                    headerChildren={<Header hideBtnSchedule={true} />}
                    selectedKeyView={selectedView}
                />

                <ButtonsBar
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    nfNumber={0}
                    removeItem={removeItem}
                    executeFunction={executeFunction}
                />
            </div>

            {selectedHistory && (
                <Modal
                    title={
                        <Space>
                            <Typography.Title level={4} style={{ margin: 0 }}>
                                Histórico Emissão NF e Pagamento # ID: {selectedHistory.id}
                            </Typography.Title>
                        </Space>
                    }
                    open={historyModalVisible}
                    onCancel={handleCloseHistory}
                    footer={null}
                    width={600}
                    destroyOnClose
                >
                    {loadingHistory ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Typography.Text type="secondary">Carregando...</Typography.Text>
                        </div>
                    ) : selectedHistory?.history && selectedHistory?.history?.length > 0 ? (
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <AntList
                                dataSource={selectedHistory?.history}
                                renderItem={(item: { modifiedBy: string; modifiedAt: string; observations: string }) => (
                                    <AntList.Item>
                                        <AntList.Item.Meta
                                            title={
                                                <Space>
                                                    <Typography.Text strong>{item?.modifiedBy ?? ''}</Typography.Text>
                                                </Space>
                                            }
                                            description={
                                                <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                    <Typography.Text type="secondary">
                                                        {(() => {
                                                            const [date, time] = item?.modifiedAt?.split(' ') ?? [];
                                                            if (!date || !time) return item?.modifiedAt ?? '';
                                                            const parts = time?.split(':') ?? [];
                                                            const correctedHours = String(parseInt(parts[0], 10) - 3).padStart(2, '0');
                                                            return `${date} ${correctedHours}:${parts[1] || '00'}:${parts[2] || '00'}`;
                                                        })()}
                                                    </Typography.Text>
                                                    <Typography.Text>{(item?.observations || '') ?? ''}</Typography.Text>
                                                </Space>
                                            }
                                        />
                                    </AntList.Item>
                                )}
                            />
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Typography.Text type="secondary">
                                Nenhum histórico encontrado para esta conciliação.
                            </Typography.Text>
                        </div>
                    )}
                </Modal>
            )}
        </>
    );
};

export default HomeList;
